const firebaseConfig = {
  apiKey: "AIzaSyCxfEJqa7TtF5Fb2uPD0pDh6wp2uoNvodY",
  authDomain: "mind-a4c93.firebaseapp.com",
  projectId: "mind-a4c93",
  storageBucket: "mind-a4c93.appspot.com",
  messagingSenderId: "5746548347",
  appId: "1:5746548347:web:a6148fb8d9ce53170a8cde"
};
  export default firebaseConfig;